module.exports = __webpack_public_path__ + "static/media/cloud-computing.ec3551d3.png";